import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#00DB66",
      main: "#009043",
      dark: "#007537",
    },
  },
});

export default theme;